import React, { Fragment, useEffect, useState } from "react";
import { Col, Card, Dropdown } from "react-bootstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import Pagination from "@mui/material/Pagination";
import Box from "@mui/material/Box";
import * as constants from "../../../utils/Constants";
import { ToastContainer, toast } from "react-toastify";
import { LinearProgress, CircularProgress } from "@material-ui/core";
import "react-toastify/dist/ReactToastify.css";

const ListJob = () => {
  const { state } = useLocation();
  const location = useLocation();
  const [isSpin, setIsSpin] = useState(false);
  const [page, setPage] = useState(
    Number(location?.pageCallBack) > 1 ? Number(location?.pageCallBack) : 1
  );
  const [pageDetails, setPageDetails] = useState({});
//   const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [sortBy, setSortBy] = useState(location?.sortByCallBack);
  const [searchText, setSearchText] = useState(location?.searchCallBack);
  const [order, setOrder] = useState(location?.orderCallBack);
  const history = useHistory();
  // const [sorting, setSorting] = useState([])
  let jobData = [];
  let loggedInUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    window.scrollTo(0, 0);
    getListJobs(page - 1, searchText, sortBy, order);
    fetch(constants?.ListCompanyNamesUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setJobCompanyName(result.data);
      });
    fetch(constants?.ListJobTitleUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setJobTitle(result.data);
      });
    fetch(constants.ListStatesUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setStates(result);
      });
    fetch(constants.ListIndustriesUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setIndustries(result);
      });
    fetch(constants.ListNewKeySkillsurl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setkeySkills(result.data);
      });
    fetch(constants.ListNewQualificationsurl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setQualifications(result.data);
      });
    fetch(constants.ListMinCtc, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setMinCtc(result.data);
      });
    fetch(constants.ListMaxCtc, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setMaxCtc(result.data);
      });

    fetch(constants.ListMinExperience, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setMinExperience(result.data);
      });
    fetch(constants.ListMaxExperience, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setMaxExperience(result.data);
      });
    fetch(constants.ListPreferredCandidateLocationsUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setPjl(result.data);
      });
  }, []);

  function getListJobs(page, search, sort, order) {
    let url =
      loggedInUser.roles === "Recruitment Agent"
        ? `${constants.ListJobsUrl}/${loggedInUser.userId}`
        : `${constants.ListJobsUrl}`;
    fetch(
      `${url}?page=${page}&search=${search || ""}&sortBy=${sort || ""}&sort=${
        order || ""
      }`,

      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken} `,
        },
        body: JSON.stringify(filterData || {}),
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setItems(result?.data?.content);
          setPageDetails(result.data);
        },
        (error) => {
          setIsLoaded(true);
          console.log("Error", error)
        }
      );
  }

  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setPage(value);
    getListJobs(value - 1, searchText, sortBy, order);
  };

  // const handleSorting = (key, event) => {
  //     setSorting({ key, value: event.target.value });
  // };

  //popup filter
  const openFilter2 = () => {
    document.getElementById("staticBackdrop").style.display = "none";
  };
  const clearFilter = () => {
    window.location.reload();
  };
  const openFilter = () => {
    document.getElementById("staticBackdrop").style.top =
      document.getElementById("popupbox").getBoundingClientRect().y + 20 + "px";
    document.getElementById("staticBackdrop").style.left =
      document.getElementById("popupbox").getBoundingClientRect().x -
      460 +
      "px";
    document.getElementById("staticBackdrop").style.display = "block";
    if (openFilterClicked) {
      openFilter2();
      openFilterClicked = false;
    } else {
      openFilterClicked = true;
    }
  };
  var openFilterClicked = false;

  //  Filter Dropdown
  // const [filterData, setFilterData] = useState({})
  const [filterData, setFilterData] = useState({
    ...state,
    ...location?.filterDataCallback,
  });
  const [jobCompanyName, setJobCompanyName] = useState([]);
  const [loginData, setLoginData] = useState({});
  const [states, setStates] = useState([]);
  // const [designations, setDesignations] = useState([])
  const [keySkills, setkeySkills] = useState([]);
  const [qualifications, setQualifications] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [minCtc, setMinCtc] = useState([]);
  const [maxCtc, setMaxCtc] = useState([]);
  const [minExperience, setMinExperience] = useState([]);
  const [maxExperience, setMaxExperience] = useState([]);
  const [preferredCandidateLocation, setPjl] = useState([]);
  const [jobTitle, setJobTitle] = useState([]);

  let existingKeySkill = [];
  let existingIndustry = [];
  let existingPreferredJobLocation = [];
  let existingStates = [];

  const keySkillsOptions = () => {
    return keySkills?.map((keys) => ({ label: keys, value: keys }));
  };
  const statesOptions = () => {
    return states?.map((keys) => ({
      label: keys.stateName,
      value: keys.stateName,
    }));
  };
  const minExperienceOptions = () => {
    return minExperience?.map((keys) => ({ label: keys, value: keys }));
  };
  const maxExperienceOptions = () => {
    return maxExperience?.map((keys) => ({ label: keys, value: keys }));
  };
  const companyNameOptions = () => {
    return jobCompanyName?.map((keys) => ({
      label: keys.companyName,
      value: keys.companyName,
    }));
  };
  const jobTitleOptions = () => {
    return jobTitle?.map((keys) => ({ label: keys, value: keys }));
  };

  const qualificationOptions = () => {
    return qualifications?.map((qual) => ({ label: qual, value: qual }));
  };
  const minCtcOptions = () => {
    return minCtc?.map((keys) => ({ label: keys, value: keys }));
  };
  const maxCtcOptions = () => {
    return maxCtc?.map((keys) => ({ label: keys, value: keys }));
  };
  const remoteLocationOptions = () => {
    return [
      { label: "WFH", value: "wfh" },
      { label: "Office", value: "office" },
      { label: "Hybrid", value: "hybrid" },
    ];
  };
  const handleRemoteLocation = (value) => {
    const newLoginData = { ...filterData };
    let remoteLocationChange = [];
    if (value) {
      for (var i = 0; i < value.length; i++) {
        remoteLocationChange.push(value[i].value.toString());
      }
      newLoginData["remoteLocation"] = remoteLocationChange;
    } else {
      remoteLocationChange.length = 0;
      newLoginData["remoteLocation"] = remoteLocationChange;
    }
    setFilterData(newLoginData);
  };
  const industryOptions = () => {
    return industries?.map((keys) => ({
      label: keys.industriesName,
      value: keys.industriesName,
    }));
  };
  const preferredJobLocationOptions = () => {
    return preferredCandidateLocation?.map((keys) => ({
      label: keys.preferredCandidateLocationName,
      value: keys.preferredCandidateLocationName,
    }));
  };
  const handleKeySkills = (value) => {
    const newLoginData = { ...filterData };
    let keySkillChange = [];
    if (value) {
      for (var i = 0; i < value.length; i++) {
        keySkillChange.push(value[i].value.toString());
      }
      newLoginData["keySkills"] = keySkillChange;
    } else {
      keySkillChange.length = 0;
      newLoginData["keySkills"] = keySkillChange;
    }
    setFilterData(newLoginData);
  };
  const handleStates = (value) => {
    const newLoginData = { ...filterData };
    let statesChange = [];
    if (value) {
      for (var i = 0; i < value.length; i++) {
        statesChange.push(value[i].value.toString());
      }
      newLoginData["states"] = statesChange;
    } else {
      statesChange.length = 0;
      newLoginData["states"] = statesChange;
    }
    setFilterData(newLoginData);
  };
  const handlePreferredJobLocation = (value) => {
    const newLoginData = { ...filterData };
    let preferredJobLocationChange = [];
    if (value) {
      for (var i = 0; i < value.length; i++) {
        preferredJobLocationChange.push(value[i].value.toString());
      }
      newLoginData["preferredCandidateLocation"] = preferredJobLocationChange;
    } else {
      preferredJobLocationChange.length = 0;
      newLoginData["preferredCandidateLocation"] = preferredJobLocationChange;
    }
    setFilterData(newLoginData);
  };
  const handleMinCtc = (value) => {
    const newLoginData = { ...filterData };
    let minCtcChange = [];
    if (value) {
      for (var i = 0; i < value.length; i++) {
        minCtcChange.push(value[i].value.toString());
      }
      newLoginData["minCtc"] = minCtcChange;
    } else {
      minCtcChange.length = 0;
      newLoginData["minCtc"] = minCtcChange;
    }
    setFilterData(newLoginData);
  };
  const handleMaxCtc = (value) => {
    const newLoginData = { ...filterData };
    let maxCtcChange = [];
    if (value) {
      for (var i = 0; i < value.length; i++) {
        maxCtcChange.push(value[i].value.toString());
      }
      newLoginData["maxCtc"] = maxCtcChange;
    } else {
      maxCtcChange.length = 0;
      newLoginData["maxCtc"] = maxCtcChange;
    }
    setFilterData(newLoginData);
  };
  const handleMinExperience = (value) => {
    const newLoginData = { ...filterData };
    let minExperienceChange = [];
    if (value) {
      for (var i = 0; i < value.length; i++) {
        minExperienceChange.push(value[i].value.toString());
      }
      newLoginData["minExperience"] = minExperienceChange;
    } else {
      minExperienceChange.length = 0;
      newLoginData["minExperience"] = minExperienceChange;
    }
    setFilterData(newLoginData);
  };
  const handleMaxExperience = (value) => {
    const newLoginData = { ...filterData };
    let maxExperienceChange = [];
    if (value) {
      for (var i = 0; i < value.length; i++) {
        maxExperienceChange.push(value[i].value.toString());
      }
      newLoginData["maxExperience"] = maxExperienceChange;
    } else {
      maxExperienceChange.length = 0;
      newLoginData["maxExperience"] = maxExperienceChange;
    }
    setFilterData(newLoginData);
  };
  const handleCompanyName = (value) => {
    const newLoginData = { ...loginData };
    let companyNameChange = [];
    if (value) {
      for (var i = 0; i < value.length; i++) {
        companyNameChange.push(value[i].value.toString());
      }
      newLoginData["jobCompanyName"] = companyNameChange;
    } else {
      companyNameChange.length = 0;
      newLoginData["jobCompanyName"] = companyNameChange;
    }
    setFilterData(newLoginData);
  };
  const handleJobTitle = (value) => {
    const newLoginData = { ...loginData };
    let jobTitleChange = [];
    if (value) {
      for (var i = 0; i < value.length; i++) {
        jobTitleChange.push(value[i].value.toString());
      }
      newLoginData["jobTitle"] = jobTitleChange;
    } else {
      jobTitleChange.length = 0;
      newLoginData["jobTitle"] = jobTitleChange;
    }
    setFilterData(newLoginData);
  };
  const handleQualifications = (value) => {
    const newLoginData = { ...filterData };
    let qualificationChange = [];
    if (value) {
      for (var i = 0; i < value.length; i++) {
        qualificationChange.push(value[i].value.toString());
      }
      newLoginData["qualification"] = qualificationChange;
    } else {
      qualificationChange.length = 0;
      newLoginData["qualification"] = qualificationChange;
    }
    setFilterData(newLoginData);
  };
  const handleIndustry = (value) => {
    const newLoginData = { ...filterData };
    let industryChange = [];
    if (value) {
      for (var i = 0; i < value.length; i++) {
        industryChange.push(value[i].value.toString());
      }
      newLoginData["industries"] = industryChange;
    } else {
      industryChange.length = 0;
      newLoginData["industries"] = industryChange;
    }
    setFilterData(newLoginData);
  };

  const handleFilter = () => {
    if (filterData)
      document.getElementById("staticBackdrop").style.display = "none";

    if (location?.pageCallBack) {
      getListJobs(page - 1, searchText, sortBy, order);
    } else {
      setPage(1);
      getListJobs(0, searchText, sortBy, order);
    }
  };

  if (items) {
    jobData = [...items];
  }

  const handleRowClick = (selectedRow) => {
    history.push({
      pathname: "/view-job",
      state: selectedRow,
      filterDataCallback: filterData,
      searchCallBack: searchText,
      sortByCallBack: sortBy,
      orderCallBack: order,
      pageCallBack: page,
    });
  };

  const handleSortOntable = (key, order) => {
    setSortBy(key);
    setOrder(order);
    if (location?.pageCallBack) {
      getListJobs(page - 1, searchText, key, order);
    } else {
      setPage(1);
      getListJobs(0, searchText, key, order);
    }
  };

  const handleEdit = (selectedRow) => {
    history.push({
      pathname: "/add-job",
      state: selectedRow,
    });
  };

  const handleActivation = (selectedRow) => {
    fetch(`${constants.ActiveAndDeActiveJobUrl}/${selectedRow.jobPostId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
      body: JSON.stringify({ activeFlag: "1" }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res != null) {
          let url =
            loggedInUser.roles === "Recruitment Agent"
              ? `${constants.ListJobsUrl}/${loggedInUser.userId}`
              : `${constants.ListJobsUrl}`;
          fetch(
            `${url}?page=${page}&search=${searchText || ""}&sortBy=${
              sortBy || ""
            }`,
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${loggedInUser.sessionToken}`,
              },
            }
          )
            .then((res) => res.json())
            .then(
              (result) => {
                setIsLoaded(true);
                setItems(result?.data?.content);
              },
              (error) => {
                setIsLoaded(true);
                console.log("Error", error);
              }
            );
        }
      });
  };

  useEffect(() => {
    handleSearch(searchText);
  }, [searchText]);

  const handleSearch = (search) => {
    if (location?.pageCallBack) {
      getListJobs(page - 1, search || searchText, sortBy, order);
    } else {
      setPage(1);
      getListJobs(0, search || searchText, sortBy, order);
    }
  };
  // const chackbox = document.querySelectorAll('.application_sorting_1 input')
  // const motherChackBox = document.querySelector('#checkAll')

  // const chackboxFun = (type) => {
  //     for (let i = 0; i < chackbox.length; i++) {
  //         const element = chackbox[i]
  //         if (type === 'all') {
  //             if (motherChackBox.checked) {
  //                 element.checked = true
  //             } else {
  //                 element.checked = false
  //             }
  //         } else {
  //             if (!element.checked) {
  //                 motherChackBox.checked = false
  //                 break
  //             } else {
  //                 motherChackBox.checked = true
  //             }
  //         }
  //     }
  // }
  const [checkedCandidate, setCheckedCandidate] = useState([]);
  const handleCheckBox = (e, job) => {
    const { checked } = e.target;
    const newCheckedData = [...checkedCandidate];
    if (checked) {
      newCheckedData.push(job.jobPostId);
      setCheckedCandidate(newCheckedData);
    } else {
      newCheckedData.pop(job.jobPostId);
      setCheckedCandidate(newCheckedData);
    }
  };
  // add to wishlist
  const handleWishlist = () => {
    if (checkedCandidate.length > 0) {
      setIsSpin(true);
      var url = `${constants.AddAgentWorkListUrl}/${loggedInUser.userId}`;
      var tempBody = [];
      checkedCandidate.forEach((element) => {
        tempBody.push({
          jobPostId: element,
        });
      });
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
        body: JSON.stringify(tempBody),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.message) {
            if (res.message.messageCode) {
              toast.success(`✅ ${res.message.messageDescription} !`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              setTimeout(() => {
                setIsSpin(false);
              }, 3000);
            }
          } else {
            if (res.error) {
              toast.error(`❌ ${res.error.errorMessage} !`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              setTimeout(() => {
                setIsSpin(false);
              }, 3000);
            }
          }
        });
    } else {
      toast.error(`❌ Please select at least one job !`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <Fragment>
      <div className="d-flex flex-wrap mb-4">
        <div className="mr-auto mb-2 pr-2 show-results">
          <h6 className="text-black fs-16 font-w600 mb-1">
            Showing {pageDetails?.totalElements} Jobs Results
          </h6>
          <span className="fs-14">Based your preferences</span>

          {/* cart add */}
          {loggedInUser?.roles === "Recruitment Agent" && (
            <div>
              {isSpin ? (
                <button type="button" className="btn btn-primary">
                  <CircularProgress
                    color="inherit"
                    size={24}
                    sx={{
                      color: "green",
                    }}
                  />
                </button>
              ) : (
                <button
                  style={{
                    border: "none",
                    backgroundColor: "#00ADEE",
                    textAlign: "center",
                  }}
                  type="button"
                  className="btn btn-primary btn-md"
                  id="iop"
                  onClick={handleWishlist}
                >
                  Add to Work List
                </button>
              )}
              &nbsp;&nbsp;
              <Link
                className="btn btn-primary btn-md "
                style={{
                  backgroundColor: "#00ADEE",
                  border: "none",
                }}
                to={{
                  pathname: "/work-list",
                  state: state,
                }}
              >
                View Work List
              </Link>
              <ToastContainer />
            </div>
          )}
        </div>
        <div className="d-flex flex-wrap mb-l3 mb-s1">
          <div className="input-group search-area d-xl-inline-flex">
            <input
              type="text"
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              className="form-control input-rounded mr-auto mb-md-0 mb-3"
              value={searchText}
              placeholder="Search here..."
            />
            <div className="input-group-append">
              <span className="input-group-text">
                <i
                  className="flaticon-381-search-2"
                  onClick={handleSearch}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </div>
          </div>
        </div>
        &nbsp;&nbsp;
        {/* Filter */}
        <div className="d-flex flex-wrap mb-3">
          <div>
            <div className="dropdown custom-dropdown mb-0 mt-3 mt-sm-0 mb-1">
              <button
                className="btn btn-primary"
                id="popupbox"
                onClick={openFilter}
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="18"
                  fill="currentColor"
                  class="bi bi-filter-square"
                  viewBox="0 0 16 16"
                >
                  {" "}
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />{" "}
                  <path d="M6 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z" />{" "}
                </svg>{" "}
                Filter
              </button>
              {/* popup */}
              <div>
                <div
                  className="modal fade show"
                  id="staticBackdrop"
                  style={{ width: "550px", height: "51%", top: 100, left: 503 }}
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabIndex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div
                        className=""
                        style={{
                          overflowY: "scroll",
                          width: "550px",
                          height: "300px",
                        }}
                      >
                        <div>
                          <Col lg={12}>
                            <Card>
                              <Card.Body>
                                <h4>
                                  <b>Filter Job</b>
                                </h4>
                                <br></br>
                                {/* firstcolumn  */}
                                <div className="row">
                                  <div className="col-xl-6">
                                    <div form-group row>
                                      {loggedInUser.roles !==
                                        "Recruitment Agent" && (
                                        <ReactMultiSelectCheckboxes
                                          placeholderButtonLabel="Company Name"
                                          isMulti
                                          options={companyNameOptions()}
                                          onChange={(value) => {
                                            handleCompanyName(value);
                                          }}
                                        />
                                      )}
                                    </div>{" "}
                                    {loggedInUser.roles !==
                                      "Recruitment Agent" && <br></br>}
                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="Min Experience"
                                        isMulti
                                        options={minExperienceOptions()}
                                        onChange={(value) => {
                                          handleMinExperience(value);
                                        }}
                                      />
                                    </div>
                                    <br></br>
                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="Max Experience"
                                        isMulti
                                        options={maxExperienceOptions()}
                                        onChange={(value) => {
                                          handleMaxExperience(value);
                                        }}
                                      />
                                    </div>
                                    <br></br>
                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="Min CTC"
                                        // defaultValue={[...existingCtc]}
                                        isMulti
                                        options={minCtcOptions()}
                                        onChange={(value) => {
                                          handleMinCtc(value);
                                        }}
                                      />
                                    </div>
                                    <br></br>
                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="Max CTC"
                                        // defaultValue={[...existingCtc]}
                                        isMulti
                                        options={maxCtcOptions()}
                                        onChange={(value) => {
                                          handleMaxCtc(value);
                                        }}
                                      />
                                    </div>
                                    <br></br>
                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="KeySkills"
                                        defaultValue={[...existingKeySkill]}
                                        isMulti
                                        options={keySkillsOptions()}
                                        onChange={(value) => {
                                          handleKeySkills(value);
                                        }}
                                      />
                                    </div>
                                    <br></br>
                                  </div>
                                  {/* 2ndcolumn */}
                                  <div className="col-xl-6">
                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="Job Title"
                                        isMulti
                                        options={jobTitleOptions()}
                                        onChange={(value) => {
                                          handleJobTitle(value);
                                        }}
                                      />
                                    </div>
                                    <br></br>

                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="Industries"
                                        defaultValue={[...existingIndustry]}
                                        isMulti
                                        options={industryOptions()}
                                        onChange={(value) => {
                                          handleIndustry(value);
                                        }}
                                      />
                                    </div>
                                    <br></br>

                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="Qualification"
                                        isMulti
                                        options={qualificationOptions()}
                                        onChange={(value) => {
                                          handleQualifications(value);
                                        }}
                                      />
                                    </div>
                                    <br></br>

                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="State"
                                        defaultValue={[...existingStates]}
                                        isMulti
                                        options={statesOptions()}
                                        onChange={(value) => {
                                          handleStates(value);
                                        }}
                                      />
                                    </div>
                                    <br></br>
                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="Remote Location"
                                        options={remoteLocationOptions()}
                                        onChange={(value) => {
                                          handleRemoteLocation(value);
                                        }}
                                      />
                                    </div>
                                    <br></br>
                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="Preferred Location"
                                        defaultValue={[
                                          ...existingPreferredJobLocation,
                                        ]}
                                        isMulti
                                        options={preferredJobLocationOptions()}
                                        onChange={(value) => {
                                          handlePreferredJobLocation(value);
                                        }}
                                      />
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <div>
                                      <button
                                        type="button"
                                        onClick={clearFilter}
                                        className="btn btn-primary"
                                        style={{ borderRadius: "10px" }}
                                      >
                                        Clear
                                      </button>
                                      &nbsp;&nbsp;
                                      <button
                                        type="button"
                                        onClick={handleFilter}
                                        className="btn btn-primary"
                                        style={{ borderRadius: "10px" }}
                                      >
                                        Apply
                                      </button>
                                      &nbsp;&nbsp;
                                    </div>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        &nbsp;&nbsp;
        {/* <div className="d-flex flex-wrap mb-3">
                    <DropdownButton
                        id="dropdown-basic-button"
                        variant="primary"
                        className="dropdown custom-dropdown mb-0 mr-4 mt-3 mt-sm-0 mb-1"
                        onSelect={handleSorting}
                        title={sorting?.key || "Sort By"}
                        style={{ color: '#00ADEE' }}
                    >
                        {sortList.map((item, index) => {
                            return (
                                <Dropdown.Item key={index} eventKey={item.value} onClick={() => handleSort(item.key)}>
                                    {item.value}
                                </Dropdown.Item>
                            );
                        })}
                    </DropdownButton>
                </div> */}
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <div id="application" className="dataTables_wrapper no-footer">
              {!isLoaded ? (
                <div>
                  <Box className="card" sx={{ width: "100%" }}>
                    <LinearProgress />
                  </Box>
                </div>
              ) : !items || jobData?.length <= 0 ? (
                <div>No records found</div>
              ) : (
                <table
                  className="table display mb-4 dataTablesCard table-responsive-xl card-table dataTable no-footer"
                  id="example5"
                >
                  <thead>
                    <tr role="row">
                      {/* checkbox for add job in worklist */}
                      {loggedInUser?.roles === "Recruitment Agent" && (
                        <th className="sorting">Select</th>
                      )}
                      <th className="sorting" style={{ width: "100px" }}>
                        <div class="row" style={{ flexWrap: "unset" }}>
                          <span>Job ID </span>
                          <div
                            className="alignCenter"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              class="fa fa-sort-asc"
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                // alert("hgy");
                                handleSortOntable("jobPostId", "asc");
                              }}
                              //  style={{position:'absolute' }}
                            ></i>
                            <i
                              class="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("jobPostId", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>

                      <th
                        className="sorting"
                        style={{ minWidth: "150px !important", border: "none" }}
                      >
                        <div class="row" style={{ flexWrap: "unset" }}>
                          <span>Job Title</span>
                          <div
                            className="alignCenter"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              class="fa fa-sort-asc"
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("jobTitle", "asc");
                              }}
                            ></i>
                            <i
                              class="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("jobTitle", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      {(loggedInUser.roles === "Admin" ||
                        loggedInUser.roles === "Key Account Manager") && (
                        <th
                          className="sorting"
                          style={{ minwidth: "150px", border: "none" }}
                        >
                          <div class="row" style={{ flexWrap: "unset" }}>
                            <span>Company Name</span>
                            <div
                              className="alignCenter"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "20px",
                                marginLeft: "10px",
                                alignItems: "flex-start",
                              }}
                            >
                              <i
                                class="fa fa-sort-asc"
                                style={{
                                  padding: "0px",
                                  height: "8px",
                                  marginTop: "3px",
                                }}
                                type="button"
                                onClick={() => {
                                  // alert("hgy");
                                  handleSortOntable("jobCompanyName", "asc");
                                }}
                              ></i>
                              <i
                                class="fa fa-sort-desc"
                                style={{ height: "8px", marginTop: "-3px" }}
                                type="button"
                                onClick={() => {
                                  handleSortOntable("jobCompanyName", "desc");
                                }}
                              ></i>
                            </div>
                          </div>
                        </th>
                      )}
                      <th className="sorting">
                        <div class="row" style={{ flexWrap: "unset" }}>
                          <span>Location</span>
                          <div
                            className="alignCenter"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              class="fa fa-sort-asc"
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                // alert("hgy");
                                handleSortOntable("city", "asc");
                              }}
                            ></i>
                            <i
                              class="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("city", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      <th className="sorting">View Candidates</th>

                      {loggedInUser.roles === "Recruitment Agent" && (
                        <th className="sorting">Profile submitted</th>
                      )}
                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div class="row" style={{ flexWrap: "unset" }}>
                          <span>Created Date</span>
                          <div
                            className="alignCenter"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              class="fa fa-sort-asc"
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                // alert("hgy");
                                handleSortOntable("createdDate", "asc");
                              }}
                            ></i>
                            <i
                              class="fa fa-sort-desc"
                              type="button"
                              style={{ height: "8px", marginTop: "-3px" }}
                              onClick={() => {
                                handleSortOntable("createdDate", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      <th
                        className="sorting"
                        style={{ display: "", width: "100px", border: "none" }}
                      >
                        <div class="row" style={{ flexWrap: "unset" }}>
                          <span>Status </span>
                          <div
                            className="alignCenter"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              class="fa fa-sort-asc"
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                // alert("hgy");
                                handleSortOntable("jobStatus", "asc");
                              }}
                            ></i>
                            <i
                              class="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("jobStatus", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      {loggedInUser.roles === "Recruitment Agent" && (
                        <th className="sorting"> No of agent selected</th>
                      )}
                      {loggedInUser.roles !== "Recruitment Agent" && (
                        <th className="sorting">No of candidates</th>
                      )}
                      {loggedInUser.roles !== "Recruitment Agent" && (
                        <th className="sorting">No of agents</th>
                      )}
                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div class="row" style={{ flexWrap: "unset" }}>
                          <span>Earning Potential</span>
                          <div
                            className="alignCenter"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              class="fa fa-sort-asc"
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                // alert("hgy");
                                handleSortOntable("earningPotential", "asc");
                              }}
                            ></i>
                            <i
                              class="fa fa-sort-desc"
                              type="button"
                              style={{ height: "8px", marginTop: "-3px" }}
                              onClick={() => {
                                handleSortOntable("createdDate", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>

                      {loggedInUser.roles !== "Recruitment Agent" && (
                        <th className="sorting">Action</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {jobData?.map((job) => (
                      <tr
                        role="row"
                        style={{ cursor: "pointer" }}
                        className="odd"
                      >
                        {/* checkbox for adding work list */}
                        {loggedInUser?.roles === "Recruitment Agent" && (
                          <td className={`application_sorting_1`}>
                            <div className="checkbox mr-0 align-self-center">
                              <div>
                                <input
                                  type="checkbox"
                                  onClick={(e) => handleCheckBox(e, job)}
                                  id="check1"
                                />
                              </div>
                            </div>
                          </td>
                        )}
                        <td onClick={() => handleRowClick(job)}>
                          {job.jobPostId}
                        </td>
                        <td onClick={() => handleRowClick(job)}>
                          {job.jobTitle}
                        </td>
                        {(loggedInUser.roles === "Admin" ||
                          loggedInUser.roles === "Key Account Manager") && (
                          <td onClick={() => handleRowClick(job)}>
                            {job.jobCompanyName}
                          </td>
                        )}
                        <td onClick={() => handleRowClick(job)}>{job.city}</td>
                        <td>
                          <div>
                            <Link
                              className="btn btn-primary btn-sm view-profile"
                              style={{
                                backgroundColor: "#00ADEE",
                                border: "none",
                              }}
                              to={{
                                pathname: "/applied-candidates",
                                state: job,
                              }}
                            >
                              <i className="fa fa-eye mr-2" />
                              Profile
                            </Link>
                          </div>
                        </td>
                        {loggedInUser.roles === "Recruitment Agent" && (
                          <td onClick={() => handleRowClick(job)}>
                            {job?.numberOfCandidateforAgent}
                          </td>
                        )}
                        <td onClick={() => handleRowClick(job)}>
                          {new Date(job.createdDate).toLocaleDateString(
                            "en-gb",
                            {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                            }
                          )}{" "}
                          {/* {new Date(job.createdDate).toLocaleTimeString()} */}
                        </td>
                        <td onClick={() => handleRowClick(job)}>
                          {job?.jobStatus}
                        </td>
                        {loggedInUser.roles === "Recruitment Agent" && (
                          <td onClick={() => handleRowClick(job)}>
                            {job?.numberOfAgentsWorkingOn}
                          </td>
                        )}
                        {loggedInUser.roles !== "Recruitment Agent" && (
                          <td onClick={() => handleRowClick(job)}>
                            {job.numberOfCandiate}
                          </td>
                        )}
                        {loggedInUser.roles !== "Recruitment Agent" && (
                          <td onClick={() => handleRowClick(job)}>
                            {job.numberOfAgentWorked}
                          </td>
                        )}
                        <td onClick={() => handleRowClick(job)}>
                          {job?.earningPotential?.toFixed(2)}
                        </td>
                        {loggedInUser.roles !== "Recruitment Agent" && (
                          <td>
                            <div className="d-flex align-items-center">
                              <Dropdown className="dropdown float-right custom-dropdown mb-0">
                                <Dropdown.Toggle
                                  className="i-false"
                                  data-toggle="dropdown"
                                  variant=""
                                >
                                  <svg
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                      stroke="#2E2E2E"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                                      stroke="#2E2E2E"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                                      stroke="#2E2E2E"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu dropdown-menu-right">
                                  <Dropdown.Item
                                    className="dropdown-item"
                                    onClick={() => handleEdit(job)}
                                  >
                                    Edit
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    className="dropdown-item"
                                    onClick={() => handleActivation(job)}
                                  >
                                    Deactivate Job
                                  </Dropdown.Item>
                                  <Dropdown.Item className="dropdown-item text-danger">
                                    Cancel
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              <div className="d-sm-flex text-center justify-content-between align-items-center">
                <div className="dataTables_info" id="example5_info">
                  Page: {page}
                </div>
                <div>
                  <Pagination
                    count={pageDetails?.totalPages}
                    page={page}
                    onChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ListJob;
